import { EcomPlatformViewerScriptContext } from '../../../viewer-script/types';
import { ExpressCheckoutService } from './services/ExpressCheckoutService';
import { ExpressCheckoutSettingsService } from './services/ExpressCheckoutSettingsService';
import type { ExpressContact, ExpressPaymentAuthorized } from './types';

export function createExpressCheckoutPublicApi({
  context,
}: {
  context: EcomPlatformViewerScriptContext;
}) {
  return {
    settings: () =>
      ExpressCheckoutSettingsService.fromContext(context).getSettings(),
    getInitialPaymentData: (checkoutId: string) =>
      ExpressCheckoutService.getInstance(context).getInitialPaymentData(
        checkoutId,
      ),
    onShippingContactSelected: (checkoutId: string, contact: ExpressContact) =>
      ExpressCheckoutService.getInstance(context).onShippingContactSelected(
        checkoutId,
        contact,
      ),
    onShippingMethodSelected: (checkoutId: string, methodId: string) =>
      ExpressCheckoutService.getInstance(context).onShippingMethodSelected(
        checkoutId,
        methodId,
      ),
    onPaymentAuthorized: (
      checkoutId: string,
      payment: ExpressPaymentAuthorized,
      sessionState: {
        shouldUpdateShippingAddress: boolean;
        priceVerificationToken?: string;
        deliveryOptionsErrors?: {
          hasShippingZipCodeError?: boolean;
          hasShippingSubdivisionError?: boolean;
        };
        numberOfShippingMethods: number;
        deliveryMethodCodeFromSummary?: string;
      },
      callerContext: {
        contentAppId?: string;
        contentComponentId?: string;
        successUrl?: string;
        continueShoppingUrl?: string;
      },
    ) =>
      ExpressCheckoutService.getInstance(context).onPaymentAuthorized(
        checkoutId,
        payment,
        sessionState,
        callerContext,
      ),
  };
}
